<template>
<div class="chapter">
<div class="inner_page">
<p class="break z"> </p>
<p class="chaphead m"><b>Table of Contents</b></p>
<p class="tocitem y"><a href="#/html/07_intro" id="intro">Introduction</a></p>
<table style="border-collapse: collapse; width: 100%">
<tbody><tr>
<td style="width: 20%"><p class="tocitem y"><a href="#/html/08_chap1" id="chap1">Chapter 1</a></p></td>
<td style="width: 80%"><p class="tocitem y"><a href="#/html/08_chap1">Why Prepare</a></p></td>
</tr>
<tr>
<td><p class="tocitem y"><span href="#/html/09_chap2" id="chap2" title="Link target outside of Sample">Chapter 2</span></p></td>
<td><p class="tocitem y"><span href="#/html/09_chap2" title="Link target outside of Sample">Being the Gray-Man / EDC</span></p></td>
</tr>
<tr>
<td><p class="tocitem y"><span href="#/html/10_chap3" id="chap3" title="Link target outside of Sample">Chapter 3</span></p></td>
<td><p class="tocitem y"><span href="#/html/10_chap3" title="Link target outside of Sample">Getting ready</span></p></td>
</tr>
<tr>
<td><p class="tocitem y"><span href="#/html/11_chap4" id="chap4" title="Link target outside of Sample">Chapter 4</span></p></td>
<td><p class="tocitem y"><span href="#/html/11_chap4" title="Link target outside of Sample">Digital preps</span></p></td>
</tr>
<tr>
<td><p class="tocitem y"><span href="#/html/12_chap5" id="chap5" title="Link target outside of Sample">Chapter 5</span></p></td>
<td><p class="tocitem y"><span href="#/html/12_chap5" title="Link target outside of Sample">Making a plan</span></p></td>
</tr>
<tr>
<td><p class="tocitem y"><span href="#/html/13_chap6" id="chap6" title="Link target outside of Sample">Chapter 6</span></p></td>
<td><p class="tocitem y"><span href="#/html/13_chap6" title="Link target outside of Sample">Get Home Bag</span></p></td>
</tr>
<tr>
<td><p class="tocitem y"><span href="#/html/14_chap7" id="chap7" title="Link target outside of Sample">Chapter 7</span></p></td>
<td><p class="tocitem y"><span href="#/html/14_chap7" title="Link target outside of Sample">Bug Out Bag</span></p></td>
</tr>
<tr>
<td><p class="tocitem y"><span href="#/html/15_chap8" id="chap8" title="Link target outside of Sample">Chapter 8</span></p></td>
<td><p class="tocitem y"><span href="#/html/15_chap8" title="Link target outside of Sample">Shelter in place</span></p></td>
</tr>
<tr>
<td><p class="tocitem y"><span href="#/html/16_chap9" id="chap9" title="Link target outside of Sample">Chapter 9</span></p></td>
<td><p class="tocitem y"><span href="#/html/16_chap9" title="Link target outside of Sample">I.N.C.H. bag</span></p></td>
</tr>
<tr>
<td><p class="tocitem y"><span href="#/html/17_chap10" id="chap10" title="Link target outside of Sample">Chapter 10</span></p></td>
<td><p class="tocitem y"><span href="#/html/17_chap10" title="Link target outside of Sample">After</span></p></td>
</tr>
</tbody></table>
<p class="tocitem y"><span href="#/html/18_reference" id="ref" title="Link target outside of Sample">Reference material</span></p>
<p class="tocitem y"><span href="#/html/19_final" id="fin" title="Link target outside of Sample">Final Thoughts</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_toc.vue?49409551